const staticRoutes = [
  {
    path: "/enrollment",
    name: "办理入职",
    component: () => import("@/views/layout/home"),
    status: 1,
    meta: {
      permission: true
    },
    children: [
      {
        path: "/enrollment",
        name: "办理入职",
        component: () => import("@/views/layout/subView"),
        icon: "blrz",
        status: 2,
        meta: {
          permission: true
        },
        children: [
          {
            path: "/enrollment",
            name: "办理入职",
            component: () => import("@/views/enrollment/index"),
            icon: "blrz",
            status: 2,
            meta: {
              permission: true
            }
          }
        ]
      }
    ]
  }
];

export default staticRoutes;
